/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const initialState = {
  data: [],
  isLoading: false,
  status: "INITIAL",
};

const initialTicketsState = {
  data: {
    ticketsBysessionId: {},
  },
  isLoading: false,
};

const TicketsReducer = (state = initialState, action) => {
  if (action.type === "TICKETS/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "TICKETS/SUCCESS") {
    const newState = {
      status: "SUCCESS",
      isLoading: false,
    };
    newState.data = {
      ...state.data,
      ticketsBysessionId: {
        ...state.data.ticketsBysessionId,
        [action.payload.sessionId]: action.payload.data,
      },
    };
    return newState;
  }
  if (action.type === "TICKETS/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};
const TicketTypesReducer = (state = initialState, action) => {
  if (action.type === "TICKET_TYPES/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "TICKET_TYPES/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "TICKET_TYPES/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

export { TicketsReducer, TicketTypesReducer };
